import selectEventTypeDialogTemplate from './SelectEventTypeDialog.html';

/*****************************************************************************
 * Service: SelectEventTypeDialog */
/**
 * @ngdoc     service
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.service:SelectEventTypeDialog
 * @description
 * Dialog to attach a guest to an attendee to an event.
 *****************************************************************************/
/* @ngInject */ export function SelectEventTypeDialogService($q, $uibModal, BusyScreen, Events, Tools) {
  /*****************************************************************************
   * show */
  /**
   * @ngdoc    function
   * @name     show
   * @methodOf csm.books.eventsAdmin.SelectEventTypeDialog
   * @return   {Promise}    Resolves upon close.
   * @description
   * Displays the dialog to select an event type.
   *****************************************************************************/
  this.show = function () {
    return $uibModal.open({
      animation: false,
      backdrop: 'static',
      component: 'selectEventType',
      size: 'sm'
    }).result;
  };
}

/*****************************************************************************
 * Component: selectEventType */
/**
 * @ngdoc     component
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.component:selectEventType
 * @param  {Object} modalInstance $uibModal instance from $uibModal.open method
 * @param  {Object} resolve       Resolve object passed from $uibModal.open method
 * @description
 * This...
 *****************************************************************************/
export const selectEventTypeComponent = {
  template: selectEventTypeDialogTemplate,
  bindings: { modalInstance: '<', resolve: '<' },
  controller: Controller
}

/*****************************************************************************
 * Controller: Controller */
/**
 * @ngdoc     controller
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.controller:Controller
 * @methodof  csm.books.eventsAdmin.selectEventType
 * @description
 * Controller for the selectEventType component.
 *****************************************************************************/
/* @ngInject */ function Controller($injector) {
  var $ctrl = this;
  $ctrl.ok = $injector.invoke(ok, null, { $ctrl: $ctrl });
  $ctrl.$onInit = $injector.invoke($onInit, null, { $ctrl: $ctrl });
}

/*****************************************************************************
 * ok */
/**
 * @ngdoc     function
 * @name      csm.books.eventsAdmin.controller:addGuest
 * @methodof  csm.books.eventsAdmin.selectEventType
 * @description
 * `Ok` button click handler. Closes the dialog and sends back the user's
 * selection.
 *****************************************************************************/
/* @ngInject */ function ok($ctrl, Alert) {
  return function () {
    $ctrl.validators.reset();

    /*------------------*/
    /* Validate fields. */
    /*------------------*/
    if (!$ctrl.validators.validate()) return;

    /*----------------------------------------*/
    /* No type selected, alert user and exit. */
    /*----------------------------------------*/
    if ($ctrl.event.openEvent === null) {
      Alert.error('Please select an event type');
      return;
    } else if ($ctrl.event.openEvent === false)
      /*----------------------------------------*/
      /* Ticketed event; clear the grades list. */
      /*----------------------------------------*/
      $ctrl.event.gradesList = null;
    /*-------------------------------------------------------*/
    /* Open event; the `multiSelect` component saves data    */
    /* in an array populated in the order the items were     */
    /* added. Sort in ascending order and convert to string. */
    /*-------------------------------------------------------*/ else
      $ctrl.event.gradesList = $ctrl.event.gradesList
        .sort(function (a, b) {
          return a - b;
        })
        .toString();

    /*---------------------------------------*/
    /* Close dialog and send back the event. */
    /*---------------------------------------*/
    $ctrl.close($ctrl.event);
  };
}

/*****************************************************************************
 * $onInit */
/**
 * @ngdoc     function
 * @name      csm.books.eventsAdmin.controller:$onInit
 * @methodof  csm.books.eventsAdmin.selectEventType
 * @description
 * Called by angular when the component is ready. This will set up some
 * properties from the bound values.
 *****************************************************************************/
/* @ngInject */ function $onInit($ctrl) {
  return function () {
    /** Validator Object.    */ $ctrl.validators = {};
    /** New Event model.     */ $ctrl.event = {
      id: 0,
      openEvent: null,
      gradesList: []
    };
    /** Grades Dataprovider. */ $ctrl.dpGrades = [];

    /*-----------------------------------*/
    /* Populate the grades dataprovider. */
    /*-----------------------------------*/
    for (var i = 0; i < 15; i++) {
      $ctrl.dpGrades.push({ id: i, label: (i + 1).toString() });
    }

    /*-----------------------------------------------------------*/
    /* Create references to the modal dismiss and close methods. */
    /*-----------------------------------------------------------*/
    $ctrl.dismiss = $ctrl.modalInstance.dismiss;
    $ctrl.close = $ctrl.modalInstance.close;
  };
}
